import React from 'react';
import {useSelector} from 'react-redux'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import setAuthToken from './redux/utils/setAuthToken'
import store from './redux/store'
import { setFacultyUser, facultyLogout } from './redux/action/facultyAction'
import { setAdminUser, adminLogout, adminGetAllStudent } from './redux/action/adminAction'
import { setStudentUser, studentLogout } from './redux/action/studentAction'
import LoginPage from './Pages/Admin/LoginPage'
import Home from './Pages/Student/StudentHome'
import facultyInterface from './Pages/Faculty/FacultyInterface'
import AttendenceFaculty from './Pages/Faculty/AttendenceFaculty'
import AddAttendenceFaculty from './Pages/Faculty/AddAttendenceFaculty'
import AddDailyReportFaculty from './Pages/Faculty/AddDailyReportFaculty'
import AdminAddStudent from './Pages/Admin/Student_Control/AdminAddStudent'
import AdminAddFaculty from './Pages/Admin/Faculty_control/AdminAddFaculty'
import AdminAddSubject from './Pages/Admin/AdminAddSubject'
import AdminAddNotice from './Pages/Admin/AdminAddNotice'
import StudentAttendencePage from './Pages/Student/StudentAttendencePage'
import StudentAssignment from './Pages/Student/StudentAssignment'
import FacultyStudentLoginPags from './Pages/FacultyStudentLoginPags'
import StudentTimeTable from './Pages/Student/StudentTimeTable'
import StudentNoticeBoard from './Pages/Student/StudentNoticeBoard'
import StudentSubjectList from './Pages/Student/StudentSubjectList'
import FacultyMarks from './Pages/Faculty/FacultyMarks'
import FacultyUploadMark from './Pages/Faculty/FacultyUploadMark'
import FacultyAssignment from './Pages/Faculty/FacultyAssignment'
import FacultyTimeTable from './Pages/Faculty/FacultyTimeTable'
import FacultyCreateTimeTable from './Pages/Faculty/FacultyCreateTimeTable'
import FacultyUpdateTimeTable from './Pages/Faculty/FacultyUpdateTimeTable'
import FacultySubjects from './Pages/Faculty/FacultySubjects'
import FacultyStudentControl from './Pages/Faculty/FacultyStudentControl'
import FacultyStudentView from './Pages/Faculty/FacultyStudentView'
import StudentResult from './Pages/Student/StudentResult'
import AdminAddAdmin from './Pages/Admin/AdminAddAdmin'
import AdminGetAllAdmins from './Pages/Admin/AdminGetAllAdmins'
import AdminGetAllFaculty from './Pages/Admin/Faculty_control/AdminGetAllFaculty'
import AdminFacultyTT from './Pages/Admin/Faculty_control/AdminFacultyTT'
import AdminStudentView from './Pages/Admin/Student_Control/AdminStudentView'
import AdminStudentUpdate from './Pages/Admin/Student_Control/AdminStudentUpdate'
import AdminFacultyView from './Pages/Admin/Faculty_control/AdminFacultyView'
import AdminFacultyUpdate from './Pages/Admin/Faculty_control/AdminFacultyUpdate'
import AdminGetAllStudent from './Pages/Admin/Student_Control/AdminGetAllStudents'
import AdminTransport from './Pages/Admin/AdminTransport'
import AdminHostel from './Pages/Admin/AdminHostel'
import AdminGetAllSubject from './Pages/Admin/AdminGetAllSubjects'
import AdminHome from './Pages/Admin/AdminHome'
 
if (window.localStorage.facultyJwtToken) {
  setAuthToken(localStorage.facultyJwtToken);
  const decoded = jwt_decode(localStorage.facultyJwtToken);
 
  store.dispatch(setFacultyUser(decoded));

  // Check for expired token
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    store.dispatch(facultyLogout());
    window.location.href = '/';
  }
}
else if (window.localStorage.studentJwtToken) {
  setAuthToken(localStorage.studentJwtToken);
  const decoded = jwt_decode(localStorage.studentJwtToken);

  store.dispatch(setStudentUser(decoded));

  // Check for expired token
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    store.dispatch(studentLogout());
    window.location.href = '/';
  } 
}
else if (window.localStorage.adminJwtToken) {
  setAuthToken(localStorage.adminJwtToken);
  const decoded = jwt_decode(localStorage.adminJwtToken);

  store.dispatch(setAdminUser(decoded));

  // Check for expired token
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    store.dispatch(adminLogout());
    window.location.href = '/';
  } 
}

function App() {
  const store = useSelector((store)=>store)
  return (
    <div>
      <Router>
        <Switch>
          <Route exact path='/' component={FacultyStudentLoginPags} />
          <Route exact path='/adminLogin' component={LoginPage} />
          <Route exact path='/home' component={Home} />
          <Route exact path='/student/studentNoticeBoard' component={StudentNoticeBoard} />
          <Route exact path='/faculty' component={facultyInterface} />
          <Route exact path='/attendenceFaculty' component={AttendenceFaculty} />
          <Route exact path='/addAttendenceFaculty' component={AddAttendenceFaculty} />
          <Route exact path='/addDailyReportFaculty' component={AddDailyReportFaculty} />
          <Route exact path='/adminHome' component={AdminHome} />
          <Route exact path="/admin/addStudent" component={AdminAddStudent} />
          <Route exact path="/admin/addFaculty" component={AdminAddFaculty} />
          <Route exact path="/admin/addSubject" component={AdminAddSubject} />
          <Route exact path="/admin/addNotice" component={AdminAddNotice} />
          <Route exact path="/admin/addAdmin" component={AdminAddAdmin} />
          <Route exact path="/admin/AdminGetAllAdmins" component={AdminGetAllAdmins} />
          <Route exact path="/admin/allFaculties" component={AdminGetAllFaculty} />
          <Route exact path="/admin/FacultyTimeTable" component={AdminFacultyTT} />
          <Route exact path="/admin/allStudents" component={AdminGetAllStudent} />
          <Route exact path="/admin/adminStudentView/:studentId" component={AdminStudentView} />
          <Route exact path="/admin/adminStudentUpdate/:studentId" component={AdminStudentUpdate} />
          <Route exact path="/admin/AdminFacultyUpdate/:facultyId" component={AdminFacultyUpdate} />
          <Route exact path="/admin/adminFacultyView/:facultyId" component={AdminFacultyView} />
          <Route exact path="/admin/AdminTransport" component={AdminTransport} />
          <Route exact path="/admin/AdminHostel" component={AdminHostel} />
          <Route exact path="/admin/allSubject" component={AdminGetAllSubject} />
          <Route exact path="/student/attendence" component={StudentAttendencePage} />
          <Route exact path="/student/assignment" component={StudentAssignment} />
          <Route exact path="/student/studentTimeTable" component={StudentTimeTable} />
          <Route exact path="/student/StudentResult" component={StudentResult} />
          <Route exact path="/uploadMarks" component={FacultyMarks} />
          <Route exact path="/FacultyUploadMark" component={FacultyUploadMark} />
          <Route exact path="/FacultyAssignment" component={FacultyAssignment} />
          <Route exact path="/FacultyStudentControl" component={FacultyStudentControl} />
          <Route exact path="/FacultyStudentView/:studentId" component={FacultyStudentView} />
          <Route exact path="/FacultySubjects" component={FacultySubjects} />
          <Route exact path="/FacultyTimeTable" component={FacultyTimeTable} />
          <Route exact path="/FacultyCreateTimeTable" component={FacultyCreateTimeTable} />
          <Route exact path="/FacultyUpdateTimeTable/:timetableId" component={FacultyUpdateTimeTable} />
          <Route exact path="/student/getAllSubjects" component={StudentSubjectList} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
